<div
  class="product-availability-info-product text-b4-s-300 text-md-b2-s-300 color-black-primary"
  [class.container-v2]="!isDesktopLgUp()"
>
  @if (forceInStock()) {
    <div class="product-availability-info-product-item">
      <sd-icon [type]="iconTypes.CAR" class="icon-size-xs icon-size-md-s"></sd-icon>
      <span>доставим со склада поставщика</span>
    </div>
  } @else {
    @if (shops(); as shops) {
      @if (shops.value?.totalAvailable; as totalAvailable) {
        <div class="product-availability-info-product-item">
          <sd-icon [type]="iconTypes.HOUSE" class="icon-size-xs icon-size-md-s"></sd-icon>
          <span>
            в наличии:
            <span class="text-b4-s-500 text-md-b2-s-500 color-green">
              {{ totalAvailable | formattedNumber: '1.0-2' }} {{ stockUnit() }}
            </span>
          </span>
        </div>
      }
    }

    <div class="product-availability-info-product-item">
      <sd-icon [type]="iconTypes.CAR" class="icon-size-xs icon-size-md-s"></sd-icon>
      <span>
        доступно для доставки:
        @if (stockLevel() && stockUnit()) {
          <span class="text-b4-s-500 text-md-b2-s-500 color-green">
            {{ stockLevel() | formattedNumber: '1.0-2' }} {{ stockUnit() }}
          </span>
        } @else {
          <span class="sd-group-skeleton-gradient-wave">
            <span class="sd-skeleton"></span>
          </span>
        }
      </span>
    </div>
  }
</div>
